import { Injectable, inject } from '@angular/core';
import { Page } from '../models/template.model';
import jsPDF from 'jspdf';
import { decode, encode } from 'html-entities';
import autoTable from 'jspdf-autotable';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class PdfService {
  pdf = new jsPDF({unit: 'px', compress: true});
  private authService = inject(AuthService);
  public readonly userProfile = this.authService.userProfile;


  phoneIcon = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAACXBIWXMAAAsTAAALEwEAmpwYAAADD0lEQVR4nO2cS3KEMAwF5VTuf8EcxtnEVVQCBNmS3hNWr2c8Ru2PEGZa710KHB/oDuxOCQBTAsCUADAlAEwJAFMCwJQAMCUATAkAUwLAfM5+sbVmXkTqvTfrfsy0GUmbKcZ5BH+gDZi2L2xC1DPAM/gRHPvPIINuD4gUzDCY6ARE01rrSBHbCxigRJSAX0RLoBSAXpsjZ8P0fcAVTzILdICf0lrr3pmSuYCITh/577dWZXtfD+USZEnvva0G0HPGvl7AYIiYleElYRsBR5gkQAQwbNSzs8G6Xy4CsmQ5Ivh6kFoAusMeeFdg7zBPQ6O5CoY2qOPzT4NrlZ6mF3AFW9n5CrdN+G4kRe8RmtKCRpbFdUwJWBlRyA3aQ8IqoWkoQ3ZkLWH1mlwFHDvH9OzWeiCstDctIHqttOZJnyKWIvclaCb4UWswgwS6WlB0ymg1O2fbmToXZPHDZ1gF33rWeWZPNDPAcuRbz6LXP5DxuEBttROVKCwLWA2e95pv1b5XCR06A5hrNFGYCJgJJNOD+8E2B7MQI591tpkJYL1AdiAzgLE0gcJUQIa0jw2K+4CdWS5FnDaqGN277x3wGbD7UuQiYPdRrcFtBtSG/Az4EjTYVYKrAOSJsyy4z4CScE/IEjQh4curL2y43Aec/hDRsRQmwgSI8ElgOBURKkCEQ8LqPmPZp3ABItizQix/szOACBDBSIh47Un7HdiNWPT7WRHp7RYP5WcukvneAl6KmJWgeZVI36s44AJE/N7bZQ++CIkAkTUJZ4HOEHwRYBZ0xUrgtG86nn13tS/qsgubAJH40Wv57EIrgGYJOsJ4as4LSgEiMYFBB1+EWICIzX/93LXt0a4WagGDTC9caEkhQMS4AvmTujKkqmkEiPgsSWgRKf+so/feIl62jliqKO8DNDAsI0decR+gwTNTiiC9gEFWEa8RMMgm4nUCBllEpMyCNBwlsG3YIhsIOMIoI30aaoGVjKnHqyXgL5FHZkoAmNdmQVkoAWBKAJgSAKYEgCkBYEoAmBIApgSAKQFgSgCYb7Ep3nyPlMFJAAAAAElFTkSuQmCC';
  globeIcon = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAACXBIWXMAAAsTAAALEwEAmpwYAAACx0lEQVR4nO2d0W7DIAxFm2n//8vsqVKVNouNr30NvedxUsHxARqWxhxjjIfg8cMO4NuRADISQEYCyEgAGQkgIwFkftkB/MdxHJBNyhjjQLSTwdFtI4ZK+hXdZLQQkJ30KzrIoApgJf4MUwRFQJfEn2GIKBXQNfFnKkWUCFgl8WcqRKTvA1ZN/uNRE3uqgJWT/yT7GtIE7JD8J5nXkiKgKvljjKPqCzPrmuACIoFWJDPSR4YE6F3QTIDnhFjbqP7cf21EgM0AZvKv/vaJcx8zyUTOBIgA9iiKwpQQXoK8gVxdbGT0I9tBXY+V0AyoDrYCb4zRmVD2RAyRfEsbVf28EpEwLcDTKWrZQHLXZ9VsnRKATH5nPLHPDqJlHsp7krGSdLeAbxn9T7JnQdoMmN0YVYK69Y3gEsAKeKY9VgzeAeXaiO30L+ZMPPLNM0DJt+PJ1TJ3QbsiAWRMArT8+LHmTDOAjASQuRWg5WceS+4g7wdkPVFCbaay+kIMTi1BZCSAjASQkQAyEkBGAshIABkJICMBZCSAjASQkQAyEkBGAshIAJnb3wXpgUyMu+cMtzNgh993srDkTksQGQkgYxKgZciPNWeaAWQkgIxZgJYhO55cpdQNRb/WMysf3XbGnsi1BLFeO5ppjxWDd7DQCzYxl7YO77G5BbCnbDXZb4UucxfkScRK4qcEfMssqHgnenoGICUwvge61K8oW4IQF2Rpo6qfVyIDKCSgurZOBdU1kCBF+1Aly6qqXUX6tsThAbIEsQvfRWHWvIN9ByAkRDZGq5athFdPjxZunbn1836mU3FZ+F1Qt8q0yD4ybpfTzg/otMYjyNqr0As2rUCbgk1edpCQfQ3pO+GVJVTErkN8PrDdIT5vnTYVsf0xVm+dNxHxdQe5vQWhowz7oMM8G6HjbEU6yzyU3xUJICMBZCSAjASQkQAyEkDmDxJt14I4BFMmAAAAAElFTkSuQmCC';


  lineHeight = 1.5;
  fontSize = 10;
  h1: number = this.fontSize * 2;
  h2: number = this.fontSize * 1.5;
  h3: number = this.fontSize;
  h4: number = this.fontSize * 0.75;
  h5: number = this.fontSize * 0.5;
  pageWidth = this.pdf.internal.pageSize.width || this.pdf.internal.pageSize.getWidth();
  pageHeight = this.pdf.internal.pageSize.height || this.pdf.internal.pageSize.getHeight();
  y = 30;
  footerSize = 0;
  headerSize = 0;
  margin = 50;
  today = new Date();
  options: Intl.DateTimeFormatOptions = {year: 'numeric', month: 'long', day: 'numeric'};
  date: string = this.today.toLocaleDateString('de-DE', this.options);
  font = this.pdf.getFont();
  private phoenixLogo = '';
  private simonsSignature = '';
  private kleinSignature = '';
  private imageAssets = new Map<string, string>();
  private exportQueue: Promise<void> = Promise.resolve();
  private bottomMargin = this.margin;

  createPdf(contracts: any[], signature: string, account: any): Promise<void> {
    const snapshot = structuredClone({contracts, account});
    return this.enqueueExport(async () => {
      if (snapshot.contracts.length === 0) {
        throw new Error('No contracts were selected.');
      }
      await this.loadAssets(snapshot.contracts.flatMap(contract => contract.pages ?? []),
        ['phoenix-logo.png', 'simons.png', 'klein.png',
          ...snapshot.contracts.filter(contract => contract.pages?.some((page: Page) => page.header_type === 1 || page.header_type === 2))
            .map(contract => `${(contract.company || 'PHOENIX').toLowerCase()}-logo.png`)]);
      this.resetDocument();
      this.addFirstPage(snapshot.account);
      this.addCartPages(snapshot.contracts, signature, snapshot.account);
      this.addContracts(snapshot.contracts, signature, snapshot.account);
      await this.pdf.save(this.safeFilename(snapshot.account?.idf || 'contract') + '_contract.pdf', {returnPromise: true});
    });
  }

  private enqueueExport(exportPdf: () => Promise<void>): Promise<void> {
    const result = this.exportQueue.then(exportPdf);
    this.exportQueue = result.catch(() => {});
    return result;
  }

  private resetDocument() {
    this.pdf = new jsPDF({unit: 'px', compress: true});
    this.pageWidth = this.pdf.internal.pageSize.getWidth();
    this.pageHeight = this.pdf.internal.pageSize.getHeight();
    this.y = this.margin;
    this.today = new Date();
    this.date = this.today.toLocaleDateString('de-DE', this.options);
    this.footerSize = 0;
    this.headerSize = 0;
    this.bottomMargin = this.margin;
    this.font = this.pdf.getFont();
    this.pdf.setFontSize(this.fontSize);
  }

  private async loadAssets(pages: Page[], required: string[] = []) {
    const paths = new Set(required);
    const embedded = new Set<string>();
    pages.forEach(page => {
      if (!page.header_html && (page.header_type === 1 || page.header_type === 2)) {
        paths.add('phoenix-logo.png');
      }
      const html = this.templateHtml(page.header_html || '') + this.templateHtml(page.body_html || '');
      const parsed = new DOMParser().parseFromString(html, 'text/html');
      parsed.querySelectorAll('img').forEach(image => {
        const src = image.getAttribute('src') || '';
        if (src.startsWith('data:image/')) {
          embedded.add(src);
        } else if (src && !src.startsWith('data:')) {
          const url = new URL(src, document.baseURI);
          if (url.origin !== new URL(document.baseURI).origin) {
            throw new Error('External contract images must be embedded before PDF export.');
          }
          paths.add(src);
        }
      });
      if (page.body_html?.includes('[simons]')) paths.add('simons.png');
      if (page.body_html?.includes('[klein]')) paths.add('klein.png');
    });
    const [assets, embeddedAssets] = await Promise.all([
      Promise.all([...paths].map(async path => [path, await this.loadImageAsset(path)] as const)),
      Promise.all([...embedded].map(async src => [src, await this.normalizeImage(src)] as const))
    ]);
    this.imageAssets = new Map([...assets, ...embeddedAssets]);
    this.phoenixLogo = this.imageAssets.get('phoenix-logo.png') || '';
    this.simonsSignature = this.imageAssets.get('simons.png') || '';
    this.kleinSignature = this.imageAssets.get('klein.png') || '';
  }

  private async loadImageAsset(path: string): Promise<string> {
    const response = await fetch(new URL(path, document.baseURI));
    if (!response.ok) {
      throw new Error(`Could not load PDF image asset "${path}" (${response.status}).`);
    }
    const blob = await response.blob();
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => typeof reader.result === 'string'
        ? this.normalizeImage(reader.result).then(resolve, reject)
        : reject(new Error(`Could not convert PDF image asset "${path}" to a data URL.`));
      reader.onerror = () => reject(reader.error ?? new Error(`Could not read PDF image asset "${path}".`));
      reader.readAsDataURL(blob);
    });
  }

  // jsPDF embeds PNG/JPEG reliably; SVG, GIF, WebP etc. are rasterized to PNG first.
  private async normalizeImage(dataUrl: string): Promise<string> {
    if (/^data:image\/(png|jpe?g)[;,]/i.test(dataUrl)) {
      return dataUrl;
    }
    const image = new Image();
    await new Promise<void>((resolve, reject) => {
      image.onload = () => resolve();
      image.onerror = () => reject(new Error('A contract image could not be decoded for PDF export.'));
      image.src = dataUrl;
    });
    const scale = 2;
    const canvas = document.createElement('canvas');
    canvas.width = Math.max(1, Math.round((image.naturalWidth || 300) * scale));
    canvas.height = Math.max(1, Math.round((image.naturalHeight || 150) * scale));
    const context = canvas.getContext('2d');
    if (!context) {
      throw new Error('A contract image could not be converted for PDF export.');
    }
    context.drawImage(image, 0, 0, canvas.width, canvas.height);
    return canvas.toDataURL('image/png');
  }

  createTemplatePdf(pages: Page[], accountId: string, title: string): Promise<void> {
    const snapshot = structuredClone(pages);
    return this.enqueueExport(async () => {
      if (!snapshot.length) {
        throw new Error('No contract pages were prepared.');
      }
      await this.loadAssets(snapshot, snapshot.some(page => page.header_type === 1 || page.header_type === 2)
        ? ['phoenix-logo.png'] : []);
      this.resetDocument();
      const ranges = snapshot.sort((left, right) => left.sort_index - right.sort_index).map((page, index) => {
        if (index > 0) {
          this.pdf.addPage();
          this.y = this.margin;
        }
        return this.renderPage(page, 'PHOENIX', title, '');
      });
      this.addFooters(ranges);
      await this.pdf.save(`${this.safeFilename(accountId)}_${this.safeFilename(title)}_contract.pdf`, {returnPromise: true});
    });
  }

  private safeFilename(value: unknown): string {
    return String(value ?? '').trim().replace(/[<>:"/\\|?*\x00-\x1f]/g, '_').slice(0, 100).replace(/[. ]+$/g, '') || 'contract';
  }

  private templateHtml(html: string): string {
    return /<[a-z][\s\S]*>/i.test(html) ? html : decode(html);
  }

  private addFirstPage(account: any) {
    this.pdf.addImage(this.phoenixLogo, 'png', this.pageWidth - 2 * this.margin, this.y, 50, 40);

    this.y += 40;

    this.pdf.setFontSize(this.h1);
    this.pdf.text('Vertrag ', this.margin, this.y);
    const dim = this.pdf.getTextDimensions('Vertrag ', {maxWidth: this.pageWidth - (this.margin * 2) });
    const height = Math.ceil(dim.h);
    this.y += height * this.lineHeight;

    this.pdf.setFontSize(this.fontSize);
    this.pdf.text('zwischen', this.margin, this.y,{ lineHeightFactor: this.lineHeight});

    this.y += this.fontSize * this.lineHeight;

    this.pdf.text('PHOENIX Pharmahandel GmbH & Co KG\n' +
      'Pfingstweidstraße 10-12\n' +
      '68199 Mannheim\n', this.margin, this.y, { lineHeightFactor: this.lineHeight});

    this.y += this.margin;

    this.pdf.text('und', this.margin, this.y, { lineHeightFactor: this.lineHeight});
    this.y += this.margin;

    this.writeText(this.accountText(account));
    this.y += this.fontSize * 2;
    this.writeText('Überreicht durch:\n' +
      [this.userProfile()?.lastName, this.userProfile()?.firstName].filter(Boolean).join(', ') + '\n' +
      this.date);

    this.pdf.addPage();
  }

  private addCartPages(contracts: any[], sign: string, account: any) {
    this.y = 50;

    this.pdf.setFontSize(this.h1);

    this.pdf.text('Vertrag ', this.margin, this.y, {lineHeightFactor: this.lineHeight});
    this.y += this.fontSize * this.lineHeight;

    this.pdf.setFontSize(this.fontSize);

    const headers = [
      {header: 'Pos.', dataKey: 'pos'},
      {header: 'Artikelnummer', dataKey: 'sku'},
      {header: 'Bezeichnung', dataKey: 'name'},
      {header: 'Einmalig', dataKey: 'price'},
      {header: 'Monatlich', dataKey: 'monthly'}];

    const data = this.prepareCart(contracts);
    autoTable(this.pdf, {
      columns: headers,
      body: data,
      startY: this.y,
      margin: {top: this.margin, bottom: this.margin, left: this.margin, right: this.margin},
      styles: {fontSize: this.fontSize},
      theme: 'grid',
      foot: [[ '', '', 'Gesamtsummen',
        this.currency(contracts.reduce((total, item) => total + this.amount(item.price), 0)),
        this.currency(contracts.reduce((total, item) => total + this.amount(item.monthly), 0)) ]],
      showFoot: 'lastPage'
    });
    this.y = (this.pdf as jsPDF & {lastAutoTable: {finalY: number}}).lastAutoTable.finalY + 2 * this.fontSize;
    this.pdf.setFontSize(this.fontSize);
    this.writeText('Alle Preise verstehen sich zzgl. Mehrwertsteuer.');
    const start = this.formatDate(contracts[0]?.valid_from ?? contracts[0]?.validFrom);
    this.writeText('Vertragsbeginn: ' + start);
    this.writeText(this.accountText(account));
    this.writeText('Mit meiner Unterschrift auf dem Vertrag akzeptiere ich die folgenden Vertragskonditionen:');

    contracts.forEach((templ: any) => {
      this.writeText((templ.templateId ?? templ.id) + ' | ' + templ.name + ' ' + (templ.description ?? ''));
    })
    this.y += this.fontSize;

    if (account.email) this.writeText('E-Mail-Adresse der Apotheke: ' + account.email);
    this.writeText('Der Vertragsschluss erfolgt durch elektronische Bestätigung bzw. digitale Unterschrift (Textform) des Vertragstextes durch den/die vertretungsberechtigten Apothekeninhaber/in.');
    this.ensureSpace(80);
    this.pdf.text((account.city || '________________') + ', ' + this.date, this.margin, this.y + 50,{ lineHeightFactor: this.lineHeight});
    this.pdf.text('Ort, Datum', this.margin, this.y + 50 + this.fontSize, { lineHeightFactor: this.lineHeight});
    this.pdf.addImage(sign, 'png', this.margin + 120, this.y, 100, 50);
    this.y += this.fontSize * this.lineHeight + 50;
    this.pdf.text('Unterschrift Apotheke', this.margin + 120, this.y, { lineHeightFactor: this.lineHeight});
    this.y += 2 * this.fontSize * this.lineHeight;

    this.ensureSpace(80);
    let starty = this.y + 50;
    this.pdf.text('Mannheim, ' + this.date, this.margin, starty);
    starty += this.fontSize*this.lineHeight;
    this.pdf.text('Ort, Datum', this.margin, starty);


    this.pdf.addImage(this.simonsSignature, 'png', this.margin + 120, this.y, 100, 30);
    this.pdf.addImage(this.kleinSignature, 'png', this.margin + 240, this.y, 50, 30);

    starty = this.y + 50;
    this.pdf.text('ppa. Dr. Sven Simons', this.margin + 120, starty, { lineHeightFactor: this.lineHeight});
    this.pdf.text('ppa. Dr. Michael Klein', this.margin + 240, starty, { lineHeightFactor: this.lineHeight});

    starty += this.fontSize
    this.pdf.text('Leitung Marketing Deutschland', this.margin + 120, starty, { lineHeightFactor: this.lineHeight});
    this.pdf.text('Leitung Vertriebsunterstützung', this.margin + 240, starty, { lineHeightFactor: this.lineHeight});

    if (this.y < starty) {
      this.y = starty;
    }


    this.pdf.addPage();
    this.y = 50;

    this.pdf.text('Anhang:', this.margin, this.y);
    this.y += this.fontSize;

    this.pdf.text('Zugestimmte oder unterschriebene Vereinbarungen', this.margin, this.y, { lineHeightFactor: this.lineHeight});
    this.y += 2 * this.fontSize;
    data.forEach(item => {
      this.writeText(item.name);
    });


  }

  private prepareCart(contracts: any[]) {
    let data: any[] = [];

    contracts.forEach((item: any) => {
      data.push({
        pos: item.pos,
        sku: item.templateId ?? item.id,
        name: item.name,
        price: this.currency(this.amount(item.price)),
        monthly: this.currency(this.amount(item.monthly))
      })
    });

    return data;
  }

  private amount(value: unknown): number {
    const number = Number(value);
    return Number.isFinite(number) ? number : 0;
  }

  private currency(value: number): string {
    return value.toLocaleString('de-DE', {style: 'currency', currency: 'EUR'});
  }

  private accountText(account: any): string {
    const owner = account.owner ?? {};
    return [account.name, account.street, [account.zip_code ?? account.zipCode, account.city].filter(Boolean).join(' '),
      'Inhaber: ' + [owner.salutation, owner.title, owner.first_name ?? owner.firstName,
        owner.last_name ?? owner.lastName].filter(Boolean).join(' '),
      'IDF: ' + (account.idf ?? ''),
      account.sw_house || account.softwareHouse ? 'Softwarehaus: ' + (account.sw_house || account.softwareHouse) : ''
    ].filter(Boolean).join('\n');
  }

  private ensureSpace(height: number) {
    if (this.y + height > this.pageHeight - this.bottomMargin) {
      this.pdf.addPage();
      this.y = this.margin;
    }
  }

  private writeText(text: string) {
    this.pdf.setFont('helvetica', 'normal');
    this.pdf.setFontSize(this.fontSize);
    const lines = this.pdf.splitTextToSize(String(text), this.pageWidth - 2 * this.margin) as string[];
    lines.forEach(line => {
      this.ensureSpace(this.fontSize * this.lineHeight);
      this.pdf.text(line, this.margin, this.y);
      this.y += this.fontSize * this.lineHeight;
    });
    this.y += this.fontSize;
  }

  private addContracts(contracts: any[], sign: any, account: any) {
    contracts.forEach((contract: any) => {
      if (contract.pages?.length > 0) {
        const ranges = [...contract.pages].sort((left: Page, right: Page) => left.sort_index - right.sort_index).map((page: Page, index: number) => {
          const prepared = this.preparePage(page, account, {...contract, cart: contracts},
            contract.pages.length, this.today, index + 1, sign);
          this.pdf.addPage();
          this.y = this.margin;
          return this.renderPage(prepared, contract.company, contract.name, contract.description);
        });
        this.addFooters(ranges);
      }
    })
  }

  preparePage(page: Page, account: any, contract: any, count: number, today = new Date(),
    pageNumber = page.sort_index + 1, signature = ''): Page {
    if (!account) {
      return {...page};
    }

    const dateId = `${today.getFullYear()}${String(today.getMonth() + 1).padStart(2, '0')}${String(today.getDate()).padStart(2, '0')}`;
    const replacements: Record<string, string> = {
      '[name]': account.name ?? '',
      '[street]': account.street ?? '',
      '[zip_code]': account.zip_code ?? account.zipCode ?? '',
      '[city]': account.city ?? '',
      '[salutation]': account.owner?.salutation ?? '',
      '[title]': account.owner?.title ?? '',
      '[first_name]': account.owner?.first_name ?? account.owner?.firstName ?? '',
      '[last_name]': account.owner?.last_name ?? account.owner?.lastName ?? '',
      '[last name]': account.owner?.last_name ?? account.owner?.lastName ?? '',
      '[gvl_last_name]': this.userProfile()?.lastName ?? '',
      '[gvl_first_name]': this.userProfile()?.firstName ?? '',
      '[gvl_id]': '',
      '[sw_house]': account.sw_house ?? account.softwareHouse ?? '',
      '[date]': today.toLocaleDateString('de-DE', this.options),
      '[contractnr]': `${dateId}_${account.idf ?? ''}_${contract.name ?? ''}`,
      '[validFrom]': this.formatDate(contract.valid_from ?? contract.validFrom),
      '[validUntil]': this.formatDate(contract.valid_until ?? contract.validUntil),
      '[email]': account.email ?? ''
    };
    const replace = (html: string, values = replacements) => Object.entries(values)
      .reduce((result, [placeholder, value]) => result.replaceAll(placeholder,
        encode(String(value)).replaceAll('[', '&#91;').replaceAll(']', '&#93;')), this.templateHtml(html || ''));
    const logo = `${(contract.company || 'PHOENIX').toLowerCase()}-logo.png`;
    const header = page.header_html || (page.header_type === 1
      ? `<img src="${logo}"><p>[contractnr]</p>` : page.header_type === 2
      ? `<img src="${logo}"><h1>[title]</h1><p>[desc]</p>` : page.header_type === 3
      ? '<h1 style="text-align:center">[title]</h1><p style="text-align:center">[desc]</p>' : '');
    const footer = replace(page.footer_template_html ?? page.footer_html);

    return {
      ...page,
      body_html: replace(page.body_html).replaceAll('[klein]', '<img src="klein.png" />')
        .replaceAll('[simons]', '<img src="simons.png" />')
        .replaceAll('[signature]', signature ? `<img src="${encode(signature)}" />` : '________________')
        .replaceAll('[cart_table]', this.cartHtml(contract.cart ?? [contract]))
        .replaceAll('[contract_list]', (contract.cart ?? [contract]).map((item: any) =>
          `<p>${encode(String(item.templateId ?? item.id ?? ''))} | ${encode(item.name ?? '')} ${encode(item.description ?? '')}</p>`
        ).join('')),
      header_html: replace(header, {...replacements, '[title]': contract.name ?? '', '[desc]': contract.description ?? ''}),
      footer_html: this.prepareFooter(footer, pageNumber, count),
      footer_template_html: footer
    };
  }

  private prepareFooter(type: string, pagenr: number, total: number) {
    return type.replaceAll('[page_nr]', String(pagenr)).replaceAll('[total]', String(total));
  }

  private cartHtml(contracts: any[]): string {
    const row = (cells: unknown[]) => '<tr>' + cells.map(cell => `<td>${encode(String(cell ?? ''))}</td>`).join('') + '</tr>';
    return '<table><thead>' + row(['Pos.', 'Artikelnummer', 'Bezeichnung', 'Einmalig', 'Monatlich']) +
      '</thead><tbody>' + contracts.map((item, index) => row([item.pos ?? index + 1,
        item.templateId ?? item.id, item.name,
        item.price == null ? '' : this.currency(this.amount(item.price)),
        item.monthly == null ? '' : this.currency(this.amount(item.monthly))])).join('') +
      '</tbody></table>';
  }

  addPage(page: any, company: string, name: string, description: string) {
    this.pdf.addPage();
    this.y = this.margin;
    this.addFooters([this.renderPage(page, company, name, description)]);
  }

  private renderPage(page: Page, company: string, name: string, description?: string) {
    const firstPage = this.pdf.getNumberOfPages();
    this.bottomMargin = this.margin;
    if (page.footer_html) {
      const footer = new DOMParser().parseFromString(this.templateHtml(page.footer_html), 'text/html').body.textContent || '';
      this.pdf.setFontSize(this.fontSize);
      const lines = this.pdf.splitTextToSize(footer, this.pageWidth - 2 * this.margin);
      this.bottomMargin = Math.max(this.margin, lines.length * this.fontSize * this.lineHeight + this.margin / 2);
      if (this.bottomMargin > this.pageHeight / 2) throw new Error('The contract footer is too large for a PDF page.');
    }
    if (page.header_html) {
      this.parseHeaderHtml(this.templateHtml(page.header_html));
    } else if (page.header_type) {
      switch (page.header_type) {
        case 1:
          this.header1(company, 1);
          break;
        case 2:
          this.header2(company, name, description);
          break;
        case 3:
          this.header3(name, description);
          break;
        default:
      }
    }

    this.pdf.setFontSize(this.fontSize);
    this.parseBody(this.templateHtml(page.body_html || ''));
    this.bottomMargin = this.margin;
    return {firstPage, lastPage: this.pdf.getNumberOfPages(),
      footer: this.templateHtml(page.footer_template_html ?? page.footer_html ?? '')};
  }

  private addFooters(ranges: {firstPage: number; lastPage: number; footer: string}[]) {
    if (!ranges.length) return;
    const firstPage = ranges[0].firstPage;
    const lastPage = ranges[ranges.length - 1].lastPage;
    ranges.forEach(range => {
      for (let number = range.firstPage; number <= range.lastPage; number++) {
        this.pdf.setPage(number);
        this.parseFooterHtml(this.prepareFooter(range.footer, number - firstPage + 1, lastPage - firstPage + 1),
          number - firstPage + 1);
      }
    });
    this.pdf.setPage(lastPage);
  }

  header1(company: any, contractnr: any) {
    this.pdf.addImage(this.imageAssets.get(`${String(company || 'PHOENIX').toLowerCase()}-logo.png`) || this.phoenixLogo,
      'png', this.pageWidth - 2 * this.margin, this.y, 50, 40);
    this.y += 40;

    this.pdf.setFontSize(this.h1);
    this.pdf.text('Vertragnummer '+contractnr, this.margin, this.y, { lineHeightFactor: this.lineHeight});
    this.y += this.h1;
  }

  header2(company: any, name: any, desc: any) {
    this.pdf.addImage(this.imageAssets.get(`${String(company || 'PHOENIX').toLowerCase()}-logo.png`) || this.phoenixLogo,
      'png', this.pageWidth - 2 * this.margin, this.y, 50, 40);
    this.y += 40;

    if(name) {
      this.pdf.setFontSize(this.h1);
      const nameSplit = this.pdf.splitTextToSize(name, this.pageWidth - 2 * this.margin);
      this.pdf.text(nameSplit, this.margin, this.y, { lineHeightFactor: this.lineHeight});
      this.y += nameSplit.length * this.h1 * this.lineHeight;
    }

    if(desc) {
      this.pdf.setFontSize(this.h2);
      const descSplit = this.pdf.splitTextToSize(desc, this.pageWidth - 2 * this.margin);
      this.pdf.text(descSplit, this.margin, this.y, { lineHeightFactor: this.lineHeight});
      this.y += descSplit.length * this.h2 * this.lineHeight;
    }

  }

  header3(name: any, desc: any) {
    if(name) {
      this.pdf.setFontSize(this.h1);
      const nameSplit = this.pdf.splitTextToSize(name, this.pageWidth - 2 * this.margin);
      this.pdf.text(nameSplit, this.pageWidth/2, this.y, {align: 'center', lineHeightFactor: this.lineHeight});
      this.y += nameSplit.length * this.h1 * this.lineHeight;
    }

    if(desc) {
      this.pdf.setFontSize(this.h2);
      const descSplit = this.pdf.splitTextToSize(desc, this.pageWidth - 2 * this.margin);
      this.pdf.text(descSplit, this.pageWidth/2, this.y, {align: 'center', lineHeightFactor: this.lineHeight});
      this.y += descSplit.length * this.h2 * this.lineHeight;
    }
  }

  parseBody(html: string) {
    const parsed = new DOMParser().parseFromString(html, 'text/html');
    this.renderFlow(parsed.body);
  }

  private renderFlow(container: ParentNode) {
    let inlineNodes: Node[] = [];
    const flushInline = () => {
      if (inlineNodes.length) {
        this.renderTextBlock(inlineNodes, this.fontSize, 'left');
        inlineNodes = [];
      }
    };

    container.childNodes.forEach(node => {
      if (node.nodeType === Node.TEXT_NODE) {
        if (inlineNodes.length || node.textContent?.trim()) {
          inlineNodes.push(node);
        }
        return;
      }
      if (!(node instanceof HTMLElement)) {
        return;
      }

      const tag = node.tagName.toLowerCase();
      if (tag === 'script' || tag === 'style' || tag === 'meta' || tag === 'link') {
        return;
      }
      if (tag === 'table') {
        flushInline();
        this.renderTable(node as HTMLTableElement);
        return;
      }
      if (tag === 'img') {
        flushInline();
        this.renderImage(node as HTMLImageElement);
        return;
      }
      if (/^h[1-6]$/.test(tag) || ['p', 'li', 'pre', 'blockquote'].includes(tag)) {
        flushInline();
        const level = tag.startsWith('h') ? Number(tag.substring(1)) : 0;
        const size = level === 1 ? this.h1 : level === 2 ? this.h2 : level === 3 ? this.h3 : level >= 4 ? this.h4 : this.fontSize;
        const style = node.getAttribute('style') || '';
        const align = /text-align\s*:\s*center/i.test(style) ? 'center'
          : /text-align\s*:\s*right/i.test(style) ? 'right' : 'left';
        if (tag === 'li') {
          const parent = node.parentElement;
          const index = parent ? Array.from(parent.children).filter(child => child.tagName === 'LI').indexOf(node) : 0;
          const number = Number(node.getAttribute('value')) || index + (Number(parent?.getAttribute('start')) || 1);
          node.prepend(document.createTextNode(parent?.tagName === 'OL' ? `${number}. ` : '• '));
        }
        if (node.querySelector('img, table, ul, ol')) {
          this.renderFlow(node);
        } else {
          this.renderTextBlock([node], size, align, level > 0);
        }
        return;
      }
      if (['div', 'section', 'article', 'header', 'footer', 'ul', 'ol'].includes(tag)) {
        flushInline();
        this.renderFlow(node);
        return;
      }
      if (['span', 'a', 'b', 'strong', 'i', 'em', 'u', 'small', 'br', 'sup', 'sub'].includes(tag)) {
        if (node.querySelector('img, table')) {
          flushInline();
          this.renderFlow(node);
        } else {
          inlineNodes.push(node);
        }
      } else {
        flushInline();
        this.renderFlow(node);
      }
    });
    flushInline();
  }

  private renderTextBlock(nodes: Node[], size: number, align: 'left' | 'center' | 'right', bold = false) {
    this.pdf.setFontSize(size);
    type Run = {text: string; bold: boolean; italic: boolean};
    const runs: Run[] = [];
    const collect = (node: Node, isBold = bold, isItalic = false) => {
      if (node.nodeType === Node.TEXT_NODE) {
        const text = (node.textContent || '').replace(/\s+/g, ' ');
        if (text) {
          runs.push({text, bold: isBold, italic: isItalic});
        }
        return;
      }
      if (!(node instanceof HTMLElement)) {
        return;
      }
      const tag = node.tagName.toLowerCase();
      if (['script', 'style', 'meta', 'link'].includes(tag)) return;
      if (tag === 'br') {
        runs.push({text: '\n', bold: isBold, italic: isItalic});
        return;
      }
      node.childNodes.forEach(child => collect(
        child,
        isBold || tag === 'b' || tag === 'strong' || node.style.fontWeight === 'bold' || Number(node.style.fontWeight) >= 600,
        isItalic || tag === 'i' || tag === 'em' || node.style.fontStyle === 'italic'
      ));
    };
    nodes.forEach(node => collect(node));

    type Token = Run;
    const lines: Token[][] = [[]];
    const availableWidth = this.pageWidth - 2 * this.margin;
    let lineWidth = 0;
    runs.forEach(run => {
      run.text.split(/(\n|\s+)/).filter(Boolean).forEach(text => {
        if (text === '\n') {
          lines.push([]);
          lineWidth = 0;
          return;
        }
        const token = {...run, text};
        this.pdf.setFont('helvetica', token.italic ? 'italic' : 'normal', token.bold ? 700 : 400);
        const width = this.pdf.getTextWidth(text);
        if (text.trim() && lineWidth > 0 && lineWidth + width > availableWidth) {
          lines.push([]);
          lineWidth = 0;
        }
        if (text.trim() && width > availableWidth) {
          const wrapped = this.pdf.splitTextToSize(text, availableWidth) as string[];
          wrapped.forEach((part, index) => {
            if (index > 0) {
              lines.push([]);
              lineWidth = 0;
            }
            lines[lines.length - 1].push({...token, text: part});
            lineWidth += this.pdf.getTextWidth(part);
          });
        } else {
          if (!text.trim() && lineWidth === 0) return;
          lines[lines.length - 1].push(token);
          lineWidth += width;
        }
      });
    });

    const lineHeight = size * this.lineHeight;
    lines.forEach(line => {
      while (line.length && !line[line.length - 1].text.trim()) line.pop();
      this.ensureSpace(lineHeight);
      if (!line.length) {
        this.y += lineHeight;
        return;
      }
      const textWidth = line.reduce((width, token) => {
        this.pdf.setFont('helvetica', token.italic ? 'italic' : 'normal', token.bold ? 700 : 400);
        return width + this.pdf.getTextWidth(token.text);
      }, 0);
      let x = align === 'center' ? this.margin + Math.max(0, (availableWidth - textWidth) / 2)
        : align === 'right' ? this.pageWidth - this.margin - textWidth : this.margin;
      line.forEach(token => {
        this.pdf.setFont('helvetica', token.italic ? 'italic' : 'normal', token.bold ? 700 : 400);
        if (token.text.trim()) {
          this.pdf.text(token.text, x, this.y);
        }
        x += this.pdf.getTextWidth(token.text);
      });
      this.y += lineHeight;
    });
    this.y += size === this.fontSize ? this.fontSize * 0.4 : this.fontSize * 0.6;
    this.pdf.setFontSize(this.fontSize);
    this.pdf.setFont('helvetica', 'normal');
  }

  private renderTable(table: HTMLTableElement) {
    table.querySelectorAll('td, th').forEach(cell => {
      cell.innerHTML = cell.innerHTML.replace(/<\/(p|div)>/gi, '<br>');
    });
    autoTable(this.pdf, {
      html: table,
      startY: this.y,
      margin: {top: this.margin, bottom: this.bottomMargin, left: this.margin, right: this.margin},
      styles: {fontSize: this.fontSize},
      didParseCell: data => {
        const cell = data.cell;
        if (!(cell.raw instanceof HTMLTableCellElement)) return;
        const images = cell.raw.querySelectorAll('img');
        if (!images.length) return;
        cell.styles.cellPadding = {
          top: cell.padding('top') + images.length * 44,
          bottom: cell.padding('bottom'), left: cell.padding('left'), right: cell.padding('right')
        };
      },
      didDrawCell: data => {
        const cell = data.cell;
        if (!(cell.raw instanceof HTMLTableCellElement)) return;
        cell.raw.querySelectorAll('img').forEach((image, index) => {
          const src = this.resolveImageSource(image.getAttribute('src') || '');
          if (!src) throw new Error('A contract table image could not be embedded.');
          const properties = this.pdf.getImageProperties(src);
          const scale = Math.min(100 / properties.width, 40 / properties.height,
            (cell.width - cell.padding('left') - cell.padding('right')) / properties.width);
          this.pdf.addImage(src, properties.fileType, cell.x + cell.padding('left'),
            cell.y + 4 + index * 44, properties.width * scale, properties.height * scale);
        });
      }
    });
    const lastTable = (this.pdf as jsPDF & {lastAutoTable?: {finalY: number}}).lastAutoTable;
    this.y = (lastTable?.finalY ?? this.y) + this.fontSize;
  }

  private renderImage(image: HTMLImageElement) {
    const originalSrc = image.getAttribute('src') || '';
    const src = this.resolveImageSource(originalSrc);
    if (!src) {
      throw new Error(`The contract image "${originalSrc}" could not be embedded.`);
    }
    const properties = this.pdf.getImageProperties(src);
    let width = Number(image.getAttribute('width')) || Number.parseFloat(image.style.width) || 100;
    let height = Number(image.getAttribute('height')) || Number.parseFloat(image.style.height) ||
      width * properties.height / properties.width;
    if (width <= 0 || height <= 0 || !Number.isFinite(width) || !Number.isFinite(height)) {
      throw new Error('Contract image dimensions must be positive finite numbers.');
    }
    const scale = Math.min(1, (this.pageWidth - 2 * this.margin) / width, (this.pageHeight - this.margin - this.bottomMargin) / height);
    width *= scale;
    height *= scale;
    this.ensureSpace(height);
    this.pdf.addImage(src, properties.fileType, this.margin, this.y, width, height);
    this.y += height + this.fontSize * 0.4;
  }

  private resolveImageSource(src: string): string {
    if (this.imageAssets.has(src)) return this.imageAssets.get(src)!;
    if (src.startsWith('data:image/')) {
      return src;
    }
    const filename = src.split('/').pop();
    if (filename && /-logo\.png$/i.test(filename) && this.phoenixLogo) {
      return this.phoenixLogo;
    }
    if (filename === 'phoenix-logo.png') {
      return this.phoenixLogo;
    }
    if (filename === 'simons.png') {
      return this.simonsSignature;
    }
    if (filename === 'klein.png') {
      return this.kleinSignature;
    }
    return '';
  }

  private parseHeaderHtml(html: string) {
    const parsed = new DOMParser().parseFromString(html, 'text/html');
    let headerImageBottom = this.margin;
    let imageY = this.margin / 5;
    parsed.body.querySelectorAll('img').forEach(image => {
      const src = this.resolveImageSource(image.getAttribute('src') || '');
      if (!src) {
        throw new Error('The contract header image could not be embedded.');
      }
      const properties = this.pdf.getImageProperties(src);
      let width = Number(image.getAttribute('width')) || 50;
      let height = Number(image.getAttribute('height')) || width * properties.height / properties.width;
      if (width <= 0 || height <= 0) throw new Error('Invalid contract header image dimensions.');
      const scale = Math.min(1, (this.pageWidth - 2 * this.margin) / width, this.pageHeight / 4 / height);
      width *= scale;
      height *= scale;
      this.pdf.addImage(src, properties.fileType,
        this.pageWidth - this.margin - width, imageY, width, height);
      headerImageBottom = Math.max(headerImageBottom, imageY + height);
      imageY += height + this.fontSize * 0.4;
    });
    parsed.body.querySelectorAll('img').forEach(image => image.remove());
    this.y = Math.max(this.y, headerImageBottom + this.fontSize);
    this.renderFlow(parsed.body);
    this.y = Math.max(this.y, this.margin + this.h1);
  }

  private parseFooterHtml(html: string, pageNumber: number) {
    const parsed = new DOMParser().parseFromString(html.replaceAll('[page_nr]', String(pageNumber)), 'text/html');
    const text = parsed.body.textContent?.trim();
    if (text) {
      this.pdf.setFontSize(this.fontSize);
      const lines = this.pdf.splitTextToSize(text, this.pageWidth - 2 * this.margin);
      this.pdf.text(lines, this.pageWidth - this.margin,
        this.pageHeight - this.margin / 2 - (lines.length - 1) * this.fontSize * this.lineHeight,
        {align: 'right', lineHeightFactor: this.lineHeight});
    }
  }

  private parseDate(value: string | Date | null | undefined): Date | undefined {
    if (!value) {
      return undefined;
    }
    const parsed = value instanceof Date ? value : /^\d{4}-\d{2}-\d{2}$/.test(value)
      ? new Date(Number(value.slice(0, 4)), Number(value.slice(5, 7)) - 1, Number(value.slice(8, 10)))
      : new Date(value);
    return Number.isNaN(parsed.getTime()) ? undefined : parsed;
  }

  private formatDate(value: string | Date | null | undefined): string {
    return this.parseDate(value)?.toLocaleDateString('de-DE', this.options) ?? '';
  }
}
